import { render, staticRenderFns } from "./estrellas.vue?vue&type=template&id=699d3075&scoped=true&"
import script from "./estrellas.vue?vue&type=script&lang=js&"
export * from "./estrellas.vue?vue&type=script&lang=js&"
import style0 from "./estrellas.vue?vue&type=style&index=0&id=699d3075&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "699d3075",
  null
  
)

export default component.exports